<template>
<div>
  <div class="t-400 t-primary" v-html="relation.title" />
    <span
      v-for="organisation in relation.organisations"
      :key="organisation.name"
      class="d-flex"
    >
      <i class="t-sm t-secondary width--20px mr-1 pt-1" :class="renderOrganisationCategoryIcon(organisation.organisation_types)" />
      <router-link v-if="organisation.slug_values"
        :to="{ name: 'organisation.show', params: { id: organisation.slug_values[0] }}"
        v-html="organisation.name"
      />
      <template v-else>{{organisation.name}}</template>
      <span class="t-xxs ml-2">
        <flag v-if="organisation.country" :title="renderCountryFlagTooltip(organisation.country)" :iso="organisation.country.alpha_2 | lowercase" :squared="false" class="bd-radius" />
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'relatedOrganisations',
  props: {
    relation: {
      type: Object,
      required: true
    }
  }
}
</script>
